import './about.css';
import './careers.css';


import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { 
  faChevronRight, 
  faUsers, 
  faChartLine, 
  faRocket, 
  faLaptopCode, 
  faPenNib, 
  faHeadset, 
  faPaperPlane, 
  faCheckCircle, 
  faComments,
  faBriefcase,
  faHandshake,
  faLightbulb,
  faGift
} from "@fortawesome/free-solid-svg-icons";





const Cariere = () => {
  return (
  
      <div className="general-container-footer-info-ab">
                 <div className="info-footer-container-ab">
           
           


                     <div className='tittle-ab-top'>
                        <h4>Alatura-te misiunii ContaLearn</h4>
                    </div>

                    <div className='career-hero'>
                      <p className='hero-subtitle'>Educatie contabila moderna pentru viitorii profesionisti.</p>
                      <div className='stats-career'>


                     
                        <div className='stat-item-career'>
                          <FontAwesomeIcon icon={faChartLine} className='stat-icon-career' />
                          <div className='stat-number-career'>250+</div>
                          <div className='stat-label-career'>Lectii interactive</div>
                        </div>

                        <div className='stat-item-career'>
                          <FontAwesomeIcon icon={faRocket} className='stat-icon-career' />
                          <div className='stat-number-career'>100%</div>
                          <div className='stat-label-career'>Remote & Flexibil</div>
                        </div>
                      </div>
                    </div>

<section className='section-about-2'>
  <div className='part-image-about'>
    <FontAwesomeIcon icon={faBriefcase} className='icon-about-large' style={{fontSize: '120px', color: '#13b8ab'}} />
  </div>
  <div className='part-text-about'>
    <h4>De ce ContaLearn?</h4>
    <p>
       Alatura-te misiunii noastre de a transforma modul in care se invata contabilitatea, facand-o mai simpla, mai practica si mai accesibila pentru toti.
    </p>
    <p>
      Credem ca educatia contabila nu ar trebui sa insemne doar teorie si memorare. Ea trebuie sa fie clara, interactiva si bazata pe aplicatii reale, care sa pregateasca utilizatorii pentru provocarile din viata profesionala.
    </p>
    <p>
  Daca iti doresti sa contribui la dezvoltarea unei platforme educationale care aduce un plus de valoare si face diferenta in viitorul educatiei digitale, te asteptam alaturi de noi.
</p>

<p>
  Suntem mereu in cautarea unor oameni pasionati, curiosi si dornici sa invete si sa evolueze, indiferent de nivelul lor de experienta.
</p>
  </div>
</section>


<div className='section-header-career'>
  
  <div className='section-header-career'>
  <h2>Construieste ContaLearn alaturi de noi</h2>
  <p className='section-subtitle-career'>
    Suntem la inceput de drum si cautam oameni care cred in aceasta idee.
  </p>
</div>

<section className="open-roles">
  <div className="job-category">
    <div className='job-category-header'>
      <FontAwesomeIcon icon={faLightbulb} className='job-icon' />
      <h3>Un proiect aflat la inceput</h3>
    </div>


<p>
  ContaLearn este construit in prezent de o echipa foarte mica, cu multa pasiune si dorinta de a schimba modul in care se invata contabilitatea.
</p>

<p>
  Nu avem pozitii deschise sau bugete pentru angajari in acest moment, insa suntem bucurosi sa cunoastem oameni care isi doresc sa contribuie cu idei, feedback sau implicare voluntara.
</p>

<p>
  Daca esti pasionat de educatie, contabilitate, design sau tehnologie si iti place ceea ce construim, ne-ar face placere sa stam de vorba.
</p>


  </div>

  <div className='open-application'>
    <FontAwesomeIcon icon={faPaperPlane} className='open-app-icon' />
    <p>
      Iti place misiunea ContaLearn? Scrie-ne si spune-ne cum crezi ca ai putea contribui.
    </p>
  </div>
</section>

</div>

<section className="open-roles">
  <div className="job-category">
    <div className='job-category-header'>
      <FontAwesomeIcon icon={faPenNib} className='job-icon' />
      <h3>Educatie & Continut</h3>
      <span className='job-badge'>Hai sa ne cunoastem</span>
    </div>

    <p>
      Daca esti pasionat de contabilitate si educatie, ne-ar placea sa aflam ideile tale despre cum putem face invatarea mai clara, mai practica si mai atractiva.
    </p>

    <ul className='job-list'>
      <li>
        <span className='job-title'>Autori de continut educational</span>
        <span className='job-type'>Colaborari viitoare</span>
      </li>

      <li>
        <span className='job-title'>Specialisti in contabilitate</span>
        <span className='job-type'>Feedback & idei</span>
      </li>

      <li>
        <span className='job-title'>Pasionati de e-learning</span>
        <span className='job-type'>Comunitate</span>
      </li>
    </ul>
  </div>

  <div className="job-category">
    <div className='job-category-header'>
      <FontAwesomeIcon icon={faLaptopCode} className='job-icon' />
      <h3>Tehnologie & Design</h3>
      <span className='job-badge'>Proiect in dezvoltare</span>
    </div>

    <p>
      ContaLearn este construit in prezent de o echipa foarte mica. Suntem deschisi sa cunoastem oameni pasionati de tehnologie si design care cred in aceasta misiune.
    </p>

    <ul className='job-list'>
      <li>
        <span className='job-title'>Front-End Developers</span>
        <span className='job-type'>Conexiuni viitoare</span>
      </li>

      <li>
        <span className='job-title'>UX/UI Designers</span>
        <span className='job-type'>Schimb de idei</span>
      </li>

      <li>
        <span className='job-title'>Creatori curiosi</span>
        <span className='job-type'>Networking</span>
      </li>
    </ul>
  </div>

  <div className="job-category">
    <div className='job-category-header'>
      <FontAwesomeIcon icon={faHeadset} className='job-icon' />
      <h3>Comunitate</h3>
      <span className='job-badge'>Construita impreuna</span>
    </div>

    <p>
      Ne dorim sa construim o comunitate de oameni care cred ca educatia contabila poate fi moderna, interactiva si accesibila.
    </p>

    <ul className='job-list'>
      <li>
        <span className='job-title'>Utilizatori implicati</span>
        <span className='job-type'>Feedback sincer</span>
      </li>

      <li>
        <span className='job-title'>Sustinatori ai proiectului</span>
        <span className='job-type'>Idei si recomandari</span>
      </li>

      <li>
        <span className='job-title'>Ambasadori ContaLearn</span>
        <span className='job-type'>Pe masura ce crestem</span>
      </li>
    </ul>
  </div>

  <div className='open-application'>
    <FontAwesomeIcon icon={faPaperPlane} className='open-app-icon' />

    <p>
      Iti place ceea ce construim?
      <strong> Scrie-ne si spune-ne povestea ta.</strong>
    </p>

   <br>
   </br>
   <br>
   </br>

    <div
      href='mailto:jobs@contalearn.ro'
      className='cta-button-career'
    >
      Trimite-ne CV-ul sau un mesaj
    </div>
  </div>
</section>





<div className='section-header-career'>
  <h2>Cum lucram</h2>
  <p className='section-subtitle-career'>Cultura noastra de lucru</p>
</div>

<section className="how-we-work">
  <div className="grid-3">
    <div className='work-card'>
      <div className='work-emoji'>📍</div>
      <h4>100% Remote</h4>
      <p>Colaborezi de oriunde. Ne intalnim online, ne organizam cu async tools.</p>
    </div>
    <div className='work-card'>
      <div className='work-emoji'>🕒</div>
      <h4>Flexibilitate</h4>
      <p>Lucrezi cand poti, cat poti — atat timp cat comunicam clar si ne respectam deadline-urile.</p>
    </div>
    <div className='work-card'>
      <div className='work-emoji'>🚀</div>
      <h4>Beta mindset</h4>
      <p>Testam rapid idei, iteram, imbunatatim. Nici noi nu ne oprim din invatat.</p>
    </div>
  </div>
</section>





           


<section className='section-about-2'>
  <div className='part-text-about'>
    <h4>Cautam colegi care:</h4>
    <ul className='values-list'>
      <li><FontAwesomeIcon icon={faCheckCircle} className='check-icon' /> Vor sa contribuie la o platforma educativa cu impact real</li>
      <li><FontAwesomeIcon icon={faCheckCircle} className='check-icon' /> Gandesc creativ si gasesc solutii</li>
      <li><FontAwesomeIcon icon={faCheckCircle} className='check-icon' /> Comunica deschis si colaboreaza bine in echipa</li>
      <li><FontAwesomeIcon icon={faCheckCircle} className='check-icon' /> Inteleg importanta educatiei practice si orientate spre viitor</li>
      <li><FontAwesomeIcon icon={faCheckCircle} className='check-icon' /> Sunt pasionati de educatie si tehnologie</li>
    </ul>
  </div>
  <div className='part-image-about'>
    <FontAwesomeIcon icon={faHandshake} className='icon-about-large' style={{fontSize: '120px', color: '#13b8ab'}} />
  </div>
</section>



<section className='section-about-2'>
  <div className='part-image-about'>
    <FontAwesomeIcon icon={faGift} className='icon-about-large' style={{fontSize: '120px', color: '#13b8ab'}} />
  </div>
  <div className='part-text-about'>
    <h4>Ce oferim:</h4>
    <ul className='benefits-list'>
      <li><FontAwesomeIcon icon={faCheckCircle} className='check-icon' /> <strong>Colaborare remote</strong> — lucrezi de oriunde</li>
      <li><FontAwesomeIcon icon={faCheckCircle} className='check-icon' /> <strong>Program flexibil</strong> — potrivit pentru freelanceri, studenti sau profesori</li>
      <li><FontAwesomeIcon icon={faCheckCircle} className='check-icon' /> <strong>Proiect cu misiune</strong> — educatie financiara accesibila</li>
      <li><FontAwesomeIcon icon={faCheckCircle} className='check-icon' /> <strong>Mediu prietenos</strong> — deschis la idei si initiativa</li>
      <li><FontAwesomeIcon icon={faCheckCircle} className='check-icon' /> <strong>Impact real</strong> — contribui vizibil la dezvoltarea produsului</li>
    </ul>
  </div>
</section>

<div className='section-header-career'>
  <h2>Procesul de aplicare</h2>
  <p className='section-subtitle-career'>3 pasi simpli pana la colaborare</p>
</div>

<div className='application-process'>
  <div className='process-step'>
    <div className='step-number'>1</div>
    <h4>Trimite CV-ul</h4>
    <p>Scrie-ne la <strong>jobs@contalearn.ro</strong> si spune-ne de ce te motiveaza ContaLearn</p>
  </div>
  <div className='process-step'>
    <div className='step-number'>2</div>
    <h4>Discutie informala</h4>
    <p>Vorbim online despre tine, proiect si cum ai putea contribui</p>
  </div>
  <div className='process-step'>
    <div className='step-number'>3</div>
    <h4>Start colaborare</h4>
    <p>Stabilim detaliile si incecem sa construim impreuna viitorul educatiei</p>
  </div>
</div>

<div className='final-cta-career'>
  <div className='cta-content-career'>
    <h3>Gata sa faci diferenta?</h3>
    <p>ContaLearn creste. Vrei sa cresti si tu cu noi?</p>
    <a href='mailto:jobs@contalearn.ro' className='cta-button-career'>
      <FontAwesomeIcon icon={faPaperPlane} />
      Trimite CV-ul acum
    </a>
    <p className='cta-email'>sau scrie direct la: <strong>jobs@contalearn.ro</strong></p>
  </div>
</div>

           
               
           
                 </div>
               </div>
 
  );
};

export default Cariere;
